export enum CookieKeys {
  visitorId = 'visitorTrackingCookie',
  campaignID = 'CampaignID',
  gcid = 'gcid',
  riseToken = 'riseToken',
  jwtToken = 'jwtToken',
  ga = '_ga',
  gpcSessionId = '_ga_BXPLRE2KB4',
}
